import { render, staticRenderFns } from "./new-Curricula.vue?vue&type=template&id=e5258ef6&"
import script from "./new-Curricula.vue?vue&type=script&lang=js&"
export * from "./new-Curricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports